import { render, staticRenderFns } from "./ProductDetailsnew.vue?vue&type=template&id=71766c62&scoped=true&"
import script from "./ProductDetailsnew.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsnew.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsnew.vue?vue&type=style&index=0&id=71766c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71766c62",
  null
  
)

export default component.exports